/**
 * World Cup screen (app route) ΓÇö styles only; see code-organization / styling rules.
 */

import { StyleSheet, Platform } from 'react-native';
import type { Theme } from '../src/theme/getTheme';

export interface WorldcupScreenStyleOptions {
  safeAreaTop?: number;
}

export const getWorldcupStyles = (theme: Theme, options?: WorldcupScreenStyleOptions) => {
  const safeAreaTop = options?.safeAreaTop ?? 0;
  return StyleSheet.create({
    container: {
      flex: 1,
      paddingTop: safeAreaTop,
      backgroundColor: theme.background.primary,
      ...(Platform.OS === 'web' && {
        width: '100%' as never,
        maxWidth: '100%' as never,
        overflow: 'hidden' as never,
      }),
    },
    /** Match stats is full-bleed: no WC header/tabs; safe area comes from `MatchStatsView`. */
    containerMatchStatsModal: {
      flex: 1,
      paddingTop: 0,
      backgroundColor: theme.background.primary,
      ...(Platform.OS === 'web' && {
        width: '100%' as never,
        maxWidth: '100%' as never,
        overflow: 'hidden' as never,
      }),
    },
    /**
     * Web: tab scenes can create stacking contexts that paint above earlier siblings.
     * Keep WC chrome (title + standings + menu) above `tabContent` so it never disappears.
     */
    shellHeader: {
      position: 'relative',
      zIndex: 200,
      elevation: 200,
      ...(Platform.OS === 'web' && {
        width: '100%' as never,
      }),
    },
    shellHeaderHidden: {
      display: 'none',
    },
    tabBarHidden: {
      display: 'none',
    },
    tabContent: {
      flex: 1,
      zIndex: 0,
      elevation: 0,
      // Web flexbox defaults flex items to `min-height: auto`; without this the
      // tab scene grows to its content height and the whole page scrolls instead
      // of the screen's own list/scroll view. `minHeight: 0` bounds it to the
      // viewport so internal scrollers (e.g. the leaderboard FlashList) own the
      // scroll and pinned headers stay put — matching native.
      ...(Platform.OS === 'web' && { minHeight: 0 as never }),
    },
    stackContentStyle: {
      backgroundColor: theme.background.primary,
      // Bound the navigation scene on web (flex item -> default `min-height: auto`)
      // so screens with an internal scroller (e.g. the leaderboard FlashList) keep
      // the scroll inside the list and static headers above it stay fixed.
      ...(Platform.OS === 'web' && { flex: 1 as never, minHeight: 0 as never }),
    },
    loadingContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    lockedRoot: {
      flex: 1,
      paddingTop: safeAreaTop,
      backgroundColor: theme.background.primary,
      ...(Platform.OS === 'web' && {
        width: '100%' as never,
        maxWidth: '100%' as never,
        overflow: 'hidden' as never,
      }),
    },
    lockedContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 32,
      gap: 12,
    },
    lockedTitle: {
      fontSize: 22,
      fontWeight: '800',
      color: theme.gray[800],
      textAlign: 'center',
    },
    lockedSubtitle: {
      fontSize: 15,
      fontWeight: '500',
      color: theme.gray[600],
      textAlign: 'center',
      lineHeight: 22,
    },
  });
};
